import { SchemaSearchForm } from '@frontend/pricing-search';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  getStateCounties,
  getZipLocations,
} from '../../common/services/searchFormServices';
import { lookupsActions } from '../../store/lookups';
import {
  StyledEppsContainerBody,
  StyledEppsContainerHeader,
  StyledEppsFormWrapper,
  StyledEppsParentViewSearchForm,
  StyledEppsWrapper,
} from '../global/styles/styled';
import { ErrorBanner } from './components/ErrorBanner';
import { FooterForm } from './components/FooterForm';
import { HeaderForm } from './components/HeaderForm';
import { useIsZeroBasedPricing } from '../../common/utils/customHooks/useIsZeroBasedPricing';

export const SearchForm = ({
  schema,
  schemaForm,
  activeAccordions,
  setActiveAccordions,
  accordionFieldMap,
}) => {
  const dispatch = useDispatch();
  const isZeroBasedPricing = useIsZeroBasedPricing();
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(lookupsActions.getGeocodesDataAction({ dispatch } as any));
    dispatch(lookupsActions.getLookupsDataAction({ dispatch } as any));
  }, []);

  return (
    <StyledEppsParentViewSearchForm>
      <StyledEppsContainerBody>
        <StyledEppsWrapper>
          <StyledEppsContainerHeader>
            <ErrorBanner />
          </StyledEppsContainerHeader>
          <HeaderForm />
          <StyledEppsFormWrapper>
            <SchemaSearchForm
              schema={schema}
              schemaForm={schemaForm}
              preview={false}
              getStateCounties={getStateCounties}
              getZipLocations={getZipLocations}
              activeAccordions={activeAccordions}
              setActiveAccordions={setActiveAccordions}
              isZeroBasedPricing={isZeroBasedPricing}
            />
          </StyledEppsFormWrapper>
        </StyledEppsWrapper>
      </StyledEppsContainerBody>
      <FooterForm
        schema={schema}
        schemaForm={schemaForm}
        accordionFieldMap={accordionFieldMap}
        setActiveAccordions={setActiveAccordions}
      />
    </StyledEppsParentViewSearchForm>
  );
};
